import { twJoin } from "tailwind-merge";
import { useState } from "react";
import HasAccess, { csrRoles } from "../../../components/HasAccess";
import Popover from "../../../components/Popover";
import useCurrentUserAccount from "../../../hooks/data/queries/useCurrentUserAccount";
import { TransactionLifecycle as TransLifecycle } from "../../../services/transactionsService";

function MainAmountCell({
  lifecycle,
}: {
  lifecycle: TransLifecycle;
}): JSX.Element {
  const { data: currentUserAccount } = useCurrentUserAccount();
  const [amountEl, setAmountEl] = useState<HTMLElement | null>(null);
  const [showDetail, setShowDetail] = useState<boolean>(false);

  const renderField = (label: string, value?: string, currency?: string) => {
    return (
      value && (
        <>
          <span className="font-semibold">{label}:</span>
          <span className="flex w-full justify-center">
            {currency ? `${currency} ${value}` : value}
          </span>
        </>
      )
    );
  };

  const shouldShowPopover = [
    lifecycle.payableAmount,
    lifecycle.commissionAmount,
    lifecycle.markupAmount,
    lifecycle.schemeFees,
    lifecycle.interchangeFee,
    lifecycle.processingFee,
  ].some(Boolean);

  return (
    <>
      <span
        ref={setAmountEl}
        onMouseEnter={() => setShowDetail(true)}
        onMouseLeave={() => setShowDetail(false)}
        className={twJoin(
          "inline-block truncate",
          currentUserAccount?.type === "CSR" &&
            "cursor-pointer text-primary underline"
        )}
      >
        {lifecycle.journalType !== "Settled" &&
          `${lifecycle.mainCurrency} ${lifecycle.mainAmount}`}
      </span>
      {shouldShowPopover && (
        <Popover open={showDetail} placement="bottom" referenceEl={amountEl}>
          <div className="grid w-auto auto-rows-auto grid-cols-[2fr_1fr] gap-x-10 gap-y-2 rounded-lg bg-white p-5 shadow-lg">
            {renderField(
              "Payable Amount",
              lifecycle.settlementCurrency,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "Commission Amount",
              lifecycle.commissionAmount,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "MarkUp",
              lifecycle.markupAmount,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "Scheme Fees",
              lifecycle.schemeFees,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "Interchange Fees",
              lifecycle.interchangeFee,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "Processing Fees",
              lifecycle.processingFee,
              lifecycle.settlementCurrency
            )}
            {renderField(
              "Main Amount",
              lifecycle.mainAmount,
              lifecycle.mainCurrency
            )}
          </div>
        </Popover>
      )}
    </>
  );
}

export default MainAmountCell;
